import ChooseGoalOrientationView from "./ChooseGoalOrientationView";
import OnboardingCompleteView from "./OnboardingCompleteView";
import OnboardingSlide from "../components/activities/onboarding/Slide";
import Loading from "../components/general/Loading";
import OnboardingQuestion from "../components/activities/onboarding/Question";
import NavBar from "../components/general/NavBar";
import courseApi from "../api/course";
import generalApi from "../api/general";
import userApi from "../api/user";
import { useCourse } from "../contexts/CourseProvider";
import { useEffect, useRef, useState } from "react";
import { answerOnboardingQuestion } from "../api/postactivity";
import { saveEvent } from "../api/userevents";
import xapiverbs from "../config/xapiverbs";
import { getItem, setItem } from "../utils/persistanceStorage";
import { useNavigate } from "react-router";

const OnboardingView = ({ onComplete }) => {
  const nextTimerRef = useRef(null);
  const [nextDisabled, setNextDisabled] = useState(false);
  const { course } = useCourse();
  const [activities, setActivities] = useState();
  const [current, setCurrent] = useState();
  const [currentActivity, setCurrentActivity] = useState();
  const [currentAnswer, setCurrentAnswer] = useState();
  const [complete, setComplete] = useState();
  const [goalOrientation, setGoalOrientation] = useState();
  // const [isComplete, setIsComplete] = useState();
  // const [suggestedGoalOrientation, setSuggestedGoalOrientation] = useState();
  const navigate = useNavigate();

  // Calls API to get the onboarding activity/sub activities
  useEffect(() => {
    async function fetchData() {
      var res = await courseApi.getCourseOnboardingActivity(course.courseid);
      setActivities(res.data.data);
      const index = res.data.data.findIndex((e) => e.activityid == res.data.index);
      setCurrent(index == -1 ? 0 : index);
    }
    fetchData();
  }, []);

  // Send answer and get new activity
  useEffect(() => {
    async function fetchData() {
      if (current != null && current < activities?.length) {
        setCurrentActivity((await generalApi.getActivityDetails(activities[current].activityid, null)).data.mainActivity);
      }
    }
    fetchData();
  }, [current]);

  const isConsentCurrent = () => {
    const data = currentActivity?.datajson;
    if (!data) return false;
    // Check if any question in the array has consent type
    if (Array.isArray(data?.questions)) {
      return data.questions.some((q) => q?.type == "consent");
    }
    const q = data?.question ?? data;
    return q?.type == "consent";
  };

  useEffect(() => {
    if (currentActivity?.activitytype == "onboarding_question") {
      setNextDisabled(true);
    }
  }, [currentActivity]);

  // Act on answer change for consent
  useEffect(() => {
    if (!isConsentCurrent()) return;
    const ans = currentAnswer;
    const checked = Array.isArray(ans) ? ans.some((v) => v === true) : ans === true;
    if (checked) {
      setNextDisabled(false);
      if (nextTimerRef.current) {
        clearTimeout(nextTimerRef.current);
        nextTimerRef.current = null;
      }
    }
  }, [currentAnswer]);

  const next = async () => {
    setCurrent(current + 1);
    saveEvent(currentActivity?.activityid, course.courseid, xapiverbs.LOAD);

    if (
      currentActivity != null &&
      currentAnswer != null &&
      currentActivity.datajson?.type !== "survey"
    ) {
      const res = await answerOnboardingQuestion(currentActivity.activityid, currentAnswer);
      setComplete(res.data.complete);
      // if (res.data.goalOrientation != null) {
      //   processSuggestedData(res.data.goalOrientation);
      // }
    }
  };

  const back = async () => {
    setCurrent(current - 1);
    saveEvent(currentActivity?.activityid, course.courseid, xapiverbs.LOAD);
    if (currentActivity != null && currentAnswer != null) {
    }
  };

  if (currentActivity == null) return <Loading />;

  if (complete) {
    return <OnboardingCompleteView onComplete={() => onComplete(true)} />;
  }

  return (
    <div className="z-[51] fixed top-0 left-0 flex flex-col h-screen w-screen bg-background">
      <NavBar />
      <div className="flex flex-col flex-1 min-h-0 overflow-y-auto px-4 pb-8">
        {currentActivity.activitytype == "onboarding_slide" && (
          <>
            {/* main grows to fill spare height, pushing the footer to the bottom; long content scrolls with the footer after it */}
            <main className="flex flex-col grow">
              <OnboardingSlide key={current} slide={currentActivity} />
            </main>

            <footer className="flex shrink-0 justify-center gap-6 py-6">
              <div className="flex justify-center items-center gap-8">
                <button
                  onClick={back}
                  disabled={current === 0}
                  className={`px-5 py-4 w-fit bg-accent min-w-[120px] text-center text-lg font-semibold shadow-default rounded-lg duration-200 ${
                    current === 0
                      ? "cursor-not-allowed opacity-60"
                      : "cursor-pointer hover:scale-110"
                  }`}
                >
                  Back
                </button>
                <button
                  onClick={next}
                  className="px-5 py-4 w-fit bg-accent min-w-[120px] text-center text-lg font-semibold shadow-default rounded-lg cursor-pointer hover:scale-110 duration-200"
                >
                  Next
                </button>
              </div>
            </footer>


          </>
        )}
        {currentActivity.activitytype == "onboarding_question" && (
          <>
            <div className="flex flex-col grow">
              <OnboardingQuestion
                key={current}
                activityid={currentActivity.activityid}
                question={currentActivity}
                onChange={setCurrentAnswer}
                onComplete={(completed, answers, surveyComplete) => {
                  setNextDisabled(!completed);
                  setCurrentAnswer(answers);
                  if (surveyComplete != null) setComplete(surveyComplete);
                }}
              />
            </div>
            {currentActivity.datajson?.type !== "survey" && (
              <div className="shrink-0 py-6 flex justify-center items-center gap-8">
                <button
                  onClick={back}
                  disabled={current === 0}
                  className={`p-5 w-fit bg-accent min-w-[120px] text-center text-lg font-semibold shadow-default rounded-lg duration-200 ${
                    current === 0
                      ? "cursor-not-allowed opacity-60"
                      : "cursor-pointer hover:scale-110"
                  }`}
                >
                  Back
                </button>
                <button
                  onClick={next}
                  disabled={nextDisabled}
                  className={`p-5 w-fit min-w-[120px] text-center text-lg font-semibold shadow-default rounded-lg duration-200 ${nextDisabled
                    ? "bg-background_fade text-foreground/50 cursor-not-allowed opacity-60"
                    : "bg-accent cursor-pointer hover:scale-110"
                    }`}
                  aria-disabled={nextDisabled}
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default OnboardingView;
